import { render, staticRenderFns } from "./lender-sidebar.vue?vue&type=template&id=1626a352&scoped=true"
import script from "./lender-sidebar.vue?vue&type=script&lang=js"
export * from "./lender-sidebar.vue?vue&type=script&lang=js"
import style0 from "./lender-sidebar.vue?vue&type=style&index=0&id=1626a352&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1626a352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1626a352')) {
      api.createRecord('1626a352', component.options)
    } else {
      api.reload('1626a352', component.options)
    }
    module.hot.accept("./lender-sidebar.vue?vue&type=template&id=1626a352&scoped=true", function () {
      api.rerender('1626a352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/main/components/lender-sidebar.vue"
export default component.exports